import { useContext } from 'react';
import { ConfigurationContext } from './ConfigurationContext';

export const useConfig = () => useContext(ConfigurationContext);